import React, { useEffect, useState } from 'react';
import { Divider, VStack, Text, useColorMode } from '@chakra-ui/react';
import { useCalendarSettings, useFilters } from '../../../../lib/context';
import { SelectFilterComponent } from './SelectFilterComponent';

export const LocationFilters = () => {
	const { filters, defaultFilters } = useFilters();
	const { colorMode } = useColorMode();
	const { settings } = useCalendarSettings();
	const [availableStates, setAvailableStates] = useState<string[]>([]);
	const [availableCities, setAvailableCities] = useState<string[]>([]);

	useEffect(() => {
		if (filters.selectedCountries.length === 0) {
			setAvailableStates([]);
			setAvailableCities([]);
			return;
		}

		setAvailableStates(defaultFilters.states);
	}, [filters.selectedCountries, defaultFilters.states]);

	useEffect(() => {
		if (filters.selectedStates.length === 0) {
			setAvailableCities([]);
			return;
		}

		setAvailableCities(defaultFilters.cities);
	}, [filters.selectedStates, defaultFilters.cities]);
	const { filtersTextColor, calendarBordersColor } = settings.styles[colorMode];
	return (
		<VStack w='full' alignItems='flex-start'>
			<Text fontSize='sm' fontWeight='700' mt={2} mb='0px !important' color={filtersTextColor}>
				Location
			</Text>
			<SelectFilterComponent
				label='Country'
				options={defaultFilters.countries}
				selectedOptions={filters.selectedCountries}
				filterKey='selectedCountries'
				color={filtersTextColor}
			/>
			<SelectFilterComponent
				label='State'
				options={availableStates}
				selectedOptions={filters.selectedStates}
				filterKey='selectedStates'
				color={filtersTextColor}
				disabled={availableStates.length === 0}
			/>
			<SelectFilterComponent
				label='City'
				options={availableCities}
				selectedOptions={filters.selectedCities}
				filterKey='selectedCities'
				color={filtersTextColor}
				disabled={availableCities.length === 0}
			/>
			<Divider borderColor={calendarBordersColor} />
		</VStack>
	);
};
